<template>
  <div class="row justify-space-between bg-white p-3 mx-2 rounded box-shadow">
    <div class="col text-center">
      <button
        v-if="isGuidedSigunUp"
        class="btn btn-primary ml-3"
        @click="$router.push({ name: 'GuidedSignup' })"
      >
        {{ displayName }}
      </button>
      <div v-else>
        <button
          v-if="isUserProfileV2"
          class="btn btn-primary ml-3"
          @click="$router.push({ name: 'MyProfileDetailsNew' })"
        >
          {{ displayName }}
        </button>
        <button
          v-else
          class="btn btn-primary ml-3"
          @click="$router.push({ name: 'MyProfileDetails' })"
        >
          {{ displayName }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { vxm } from '@/store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class JobApplicationLink extends Vue {
  get isGuidedSigunUp() {
    return vxm.configs.GuidedSignupEnabled;
  }
  get isUserProfileV2() {
    return vxm.configs.getGlobalConfigValue('ENABLE_USER_PROFILE_V2');
  }

  get displayName() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const submitApplication = vxm.configs.slideMenuSubSections(
        'FIND_JOBS',
        'SUBMIT_APPLICATION',
      );
      if (submitApplication && submitApplication.displayName) {
        return submitApplication.displayName;
      } else {
        return this.$t('application-link.updateprofile');
      }
    }
    return this.$t('application-link.updateprofile');
  }
}
</script>

<style></style>
